
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import SortHeader from "@/components/base/table/header/SortHeader.vue";
import { Action, Getter, State } from "vuex-class";
import Marquee from "@/components/semantics/Marquee.vue";
import { deepClone, getFormatDate, getParentArea } from "@/common/utils";
import config from "@/config";
@Component({
  name: "Market",
  components: {
    Pagination,
    Marquee,
    SortHeader,
  },
})
export default class Market extends Vue {
  @State("directCityList") private directCityList: any;
  @Action("getImage") private getImage: any;
  @Getter("cityId") private cityId: any;
  @Action("good/getGoodList") private getGoodList: any;
  @Action("good/getGoodUrl") private getGoodUrl: any;
  area_option: any = [];
  tableData1: any = new Map();
  tableData2: Array<any> = [];
  tableData3: Array<any> = [];
  loading: Boolean = false;
  current: number = 1;
  size: number = 12;
  pages: number = 0;
  total: number = 0;
  current_option: any = {};
  created() {
    this.getData(0);
  }
  async getData(type: any) {
    this.loading = true;
    // full country
    const options = {
      pageNum: this.current,
      pageSize: this.size,
      flag: 1,
    };
    let options1: any = JSON.parse(JSON.stringify(options));
    options1.city = this.cityId;
    if (type === 1) {
      options1 = {
        ...options1,
        ...this.current_option,
      };
    }
    const p1 = this.getGoodList(options1);
    p1.then(async (allList: any) => {
      const sortList = new Map();
      for (let item of allList) {
        item.imagesUrl = await this.getGoodUrl(item.commodityMainImgae);
        if (!sortList.has(item.categoryName))
          sortList.set(item.categoryName, []);
        if (sortList.get(item.categoryName).length < 4)
          sortList.get(item.categoryName).push(item);
      }
      // for (let [key, arr] in sortList.entries()) {
      // }
      this.tableData1 = sortList;
    }).finally(() => {
      this.loading = false;
    });
  }
  toMore() {}
  toPay({ id }: any) {
    this.$router.push({
      path: "/detail/market",
      query: {
        goodId: id,
      },
    });
  }
  search(options: any) {
    const filterOptions = {
      goodsName: options.likeParam,
    };
    this.current_option = {
      ...this.current_option,
      ...filterOptions,
    };
    this.getData(1);
  }
  currentChange(params: any) {
    this.current = params;
    this.getData(1);
  }
  @Watch("cityId")
  cityChange(newVal: any) {
    this.current = 1;
    this.getData(0);
  }
}
